import { css } from 'emotion'

export const QuickSearchFieldStyles = css`
  width: 100%;
`
